// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/WorkingTimeModelService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { WorkingTimeModelDtoSchema } from "../Messages/Basic_pb";
import { file_Messages_Basic } from "../Messages/Basic_pb";
import type { WorkingTimeModelCollectionDtoSchema } from "../Messages/Collections_pb";
import { file_Messages_Collections } from "../Messages/Collections_pb";
import type { UuidDtoSchema, UuidWithDeletedItemSelectionDtoSchema } from "../Messages/Common_pb";
import { file_Messages_Common } from "../Messages/Common_pb";
import type { WorkingTimeModelDetailedDtoSchema } from "../Messages/Detailed_pb";
import { file_Messages_Detailed } from "../Messages/Detailed_pb";
import type { WorkingTimeModelFiltersDtoSchema } from "../Messages/Filters_pb";
import { file_Messages_Filters } from "../Messages/Filters_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/WorkingTimeModelService.proto.
 */
export const file_Services_WorkingTimeModelService: GenFile = /*@__PURE__*/
  fileDesc("CiZTZXJ2aWNlcy9Xb3JraW5nVGltZU1vZGVsU2VydmljZS5wcm90bzLnCQoXV29ya2luZ1RpbWVNb2RlbFNlcnZpY2USlAIKE0dldFdvcmtpbmdUaW1lTW9kZWwSPi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbW1vbi5VdWlkV2l0aERlbGV0ZWRJdGVtU2VsZWN0aW9uRHRvGjwudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5Xb3JraW5nVGltZU1vZGVsRGV0YWlsZWREdG8if6DazQ8CgtPkkwJ0Wi46ASoiKS9hcGkvd29ya2luZ1RpbWVNb2RlbC9nZXRXb3JraW5nVGltZU1vZGVsEkIvYXBpL3dvcmtpbmdUaW1lTW9kZWwvZ2V0V29ya2luZ1RpbWVNb2RlbC97aWQuaGlnaF82NH0ve2lkLmxvd182NH0S0QEKFEdldFdvcmtpbmdUaW1lTW9kZWxzEjoudGltZV90cmFja2luZy5tZXNzYWdlcy5maWx0ZXJzLldvcmtpbmdUaW1lTW9kZWxGaWx0ZXJzRHRvGkEudGltZV90cmFja2luZy5tZXNzYWdlcy5jb2xsZWN0aW9ucy5Xb3JraW5nVGltZU1vZGVsQ29sbGVjdGlvbkR0byI6oNrNDwKC0+STAi86ASoiKi9hcGkvd29ya2luZ1RpbWVNb2RlbC9nZXRXb3JraW5nVGltZU1vZGVscxLHAQoWQ3JlYXRlV29ya2luZ1RpbWVNb2RlbBIxLnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuYmFzaWMuV29ya2luZ1RpbWVNb2RlbER0bxo8LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuZGV0YWlsZWQuV29ya2luZ1RpbWVNb2RlbERldGFpbGVkRHRvIjyg2s0PAILT5JMCMToBKiIsL2FwaS93b3JraW5nVGltZU1vZGVsL2NyZWF0ZVdvcmtpbmdUaW1lTW9kZWwSlAIKFlVwZGF0ZVdvcmtpbmdUaW1lTW9kZWwSMS50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmJhc2ljLldvcmtpbmdUaW1lTW9kZWxEdG8aPC50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmRldGFpbGVkLldvcmtpbmdUaW1lTW9kZWxEZXRhaWxlZER0byKIAaDazQ8AgtPkkwJ9OgEqWjE6ASoiLC9hcGkvd29ya2luZ1RpbWVNb2RlbC91cGRhdGVXb3JraW5nVGltZU1vZGVsGkUvYXBpL3dvcmtpbmdUaW1lTW9kZWwvdXBkYXRlV29ya2luZ1RpbWVNb2RlbC97aWQuaGlnaF82NH0ve2lkLmxvd182NH0S/wEKFkRlbGV0ZVdvcmtpbmdUaW1lTW9kZWwSJi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbW1vbi5VdWlkRHRvGjwudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5Xb3JraW5nVGltZU1vZGVsRGV0YWlsZWREdG8if6DazQ8AgtPkkwJ0WjE6ASoiLC9hcGkvd29ya2luZ1RpbWVNb2RlbC9kZWxldGVXb3JraW5nVGltZU1vZGVsKj8vYXBpL3dvcmtpbmdUaW1lTW9kZWwvZGVsZXRlV29ya2luZ1RpbWVNb2RlbC97aGlnaF82NH0ve2xvd182NH1CJKoCIU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5TZXJ2aWNlc2IGcHJvdG8z", [file_google_api_annotations, file_Enumerations_AuthorizationPolicy, file_Messages_Basic, file_Messages_Collections, file_Messages_Common, file_Messages_Detailed, file_Messages_Filters, file_Options_MethodOptions]);

/**
 * CRUD operations for working time models.
 *
 * @generated from service WorkingTimeModelService
 */
export const WorkingTimeModelService: GenService<{
  /**
   * Fetch a working time model specified by its id.
   * Policy: Users can only fetch working time models associated to them.
   *
   * @generated from rpc WorkingTimeModelService.GetWorkingTimeModel
   */
  getWorkingTimeModel: {
    methodKind: "unary";
    input: typeof UuidWithDeletedItemSelectionDtoSchema;
    output: typeof WorkingTimeModelDetailedDtoSchema;
  },
  /**
   * Fetch working time models according to filters.
   * Policy: Users can only fetch working time models associated to them.
   *
   * @generated from rpc WorkingTimeModelService.GetWorkingTimeModels
   */
  getWorkingTimeModels: {
    methodKind: "unary";
    input: typeof WorkingTimeModelFiltersDtoSchema;
    output: typeof WorkingTimeModelCollectionDtoSchema;
  },
  /**
   * Create a new working time model.
   *
   * @generated from rpc WorkingTimeModelService.CreateWorkingTimeModel
   */
  createWorkingTimeModel: {
    methodKind: "unary";
    input: typeof WorkingTimeModelDtoSchema;
    output: typeof WorkingTimeModelDetailedDtoSchema;
  },
  /**
   * Modify working time model properties.
   *
   * @generated from rpc WorkingTimeModelService.UpdateWorkingTimeModel
   */
  updateWorkingTimeModel: {
    methodKind: "unary";
    input: typeof WorkingTimeModelDtoSchema;
    output: typeof WorkingTimeModelDetailedDtoSchema;
  },
  /**
   * Delete the working time model with the given id.
   *
   * @generated from rpc WorkingTimeModelService.DeleteWorkingTimeModel
   */
  deleteWorkingTimeModel: {
    methodKind: "unary";
    input: typeof UuidDtoSchema;
    output: typeof WorkingTimeModelDetailedDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_WorkingTimeModelService, 0);

